export default __webpack_public_path__ + "static/mvp-a557e28450d16c58839097e699f78be8.svg";